const encodeToBase64 = (data: unknown) => {
  const objJsonStr = JSON.stringify(data);
  return Buffer.from(objJsonStr).toString('base64');
};

const runAsyncFunctionsInOrder = async (
  functionsArray: (() => Promise<void>)[]
) =>
  functionsArray.reduce(async (previousCommand, nextCommand: () => void) => {
    await previousCommand;
    return nextCommand();
  }, Promise.resolve());

const randomStringGenerator = (length: number) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const getInitials = (name: string) =>
  name
    .split(' ')
    .reduce((initials, word) => initials + word.charAt(0), '')
    .slice(0, 2);

const isFile = (path: string) => path.startsWith('file://');

const isUrlPDF = (url: string | undefined) =>
  !!url?.includes('.pdf') && !isFile(url);

export {
  encodeToBase64,
  runAsyncFunctionsInOrder,
  randomStringGenerator,
  getInitials,
  isUrlPDF,
  isFile,
};
